import { Box, makeStyles, Modal, Typography } from "@material-ui/core";
import { strings } from "common";
import React from "react";
import PropTypes from "prop-types";
import logo from "../../assets/Logo.svg";
import errorIcon from "../../assets/assignment_error.svg";

import { MainButton } from "../Common";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalContent: {
    width: "400px",
    background: "white",
    alignItems: "center",
    justifyContent: "center",
    outline: "none",
    padding: theme.spacing(12, 12, 12, 12),
  },
  center: {
    width: "100%",
    paddingBottom: theme.spacing(12),
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
  title: {
    fontWeight: "bold",
    fontSize: "1.8em",
  },
  button: {
    width: "90%",
  },
  labels: {
    marginTop: theme.spacing(12),
  },
  errorMsg: {
    color: "#FF0000",
  },
}));

interface ShipErrorModalProps {
  isOpen: boolean;
  handleEvent: React.MouseEventHandler<HTMLButtonElement> | undefined;
}

const ShipErrorModal = ({ isOpen, handleEvent }: ShipErrorModalProps) => {
  const classes = useStyles();

  return (
    <Modal
      open={isOpen}
      className={classes.modal}
      data-testid="deal-ship-error-modal"
      aria-labelledby="deal ship error"
      aria-describedby="deal ship error modal"
    >
      <Box className={classes.modalContent}>
        <Box className={classes.center}>
          <img src={logo} alt="logo" />
        </Box>
        <div className={`${classes.center}`}>
          <Typography className={classes.title}>{strings.assignment_error_title}</Typography>
        </div>
        <div className={classes.center}>
          <img src={errorIcon} alt="errorIcon" width="50" height="50" />
        </div>

        <div className={classes.center}>
          <Typography variant="h4">{strings.ship_error_msg}</Typography>
        </div>

        <div className={classes.center}>
          <MainButton className={classes.button} id="deal_ship_error_next" onClick={handleEvent}>
            {strings.ship_error_btn}
          </MainButton>
        </div>
      </Box>
    </Modal>
  );
};

ShipErrorModal.propTypes = {
  isOpen: PropTypes.bool,
  handleEvent: PropTypes.func,
};

export default ShipErrorModal;
